import React from 'react';
import { Checkbox } from 'antd';

/** چک‌باکس با فونت پروژه */
const WorkCheckbox = ({ children, ...props }) => (
  <Checkbox className="work-panel-checkbox" {...props}>
    <span style={{ fontFamily: 'CustomFont' }}>{children}</span>
  </Checkbox>
);

export default WorkCheckbox;
